import { Select, Textarea, TextInput } from "../../../common";

export type SynapseKindMatrixEntry = {
  id: string;
  synapseKindMatrixId: string;
  sourceNodeKindId: string;
  targetNodeKindId: string;
  synapseKindId: string;
  purpose: string;
  defaultSettings: string;
  scope: string;
  version: string;
  createDate: string;
  changeDate: string;
};

const scopeOptions = [
  { value: "ONTOLOGY", label: "ONTOLOGY" },
  { value: "GRAPH", label: "GRAPH" },
  { value: "NODE", label: "NODE" },
];

interface SynapseKindMatrixFormProps {
  nodeKinds: any[];
  row: SynapseKindMatrixEntry;
  onChange: (rowId: string, field: keyof SynapseKindMatrixEntry, value: string) => void;
}

const getNodeKindOptionValue = (option: any): string => {
  if (!option) return "";
  if (typeof option === "string") return option;
  return option.value ?? option.id ?? option.nodeKindId ?? option.kindId ?? "";
};

const getNodeKindOptionLabel = (option: any): string => {
  if (!option) return "";
  if (typeof option === "string") return option;
  return option.label ?? option.name ?? option.kindName ?? option.value ?? option.id ?? "";
};

const SynapseKindMatrixForm: React.FC<SynapseKindMatrixFormProps> = ({
  nodeKinds,
  row,
  onChange,
}) => {
  return (
    <div className="node-kind-builder__grid">
      <div className="node-kind-builder__grid-span-2">
        <Select
          id={`matrix-source-${row.id}`}
          name="sourceNodeKindId"
          value={row.sourceNodeKindId}
          onChange={(event) =>
            onChange(row.id, "sourceNodeKindId", event.target.value)
          }
          variant="modal"
          options={nodeKinds.map((kind) => ({
            value: getNodeKindOptionValue(kind),
            label: getNodeKindOptionLabel(kind),
          }))}
          placeholder="Select source node kind"
          label="Source Node Kind"
          hint="The source node kind for this connection"
        />
      </div>
      <div className="node-kind-builder__grid-span-2">
        <Select
          id={`matrix-target-${row.id}`}
          name="targetNodeKindId"
          value={row.targetNodeKindId}
          onChange={(event) =>
            onChange(row.id, "targetNodeKindId", event.target.value)
          }
          variant="modal"
          options={nodeKinds.map((kind) => ({
            value: getNodeKindOptionValue(kind),
            label: getNodeKindOptionLabel(kind),
          }))}
          placeholder="Select target node kind"
          label="Target Node Kind"
          hint="The target node kind for this connection"
        />
      </div>
      <div className="node-kind-builder__grid-span-2">
        <Textarea
          id={`matrix-purpose-${row.id}`}
          name="purpose"
          rows={3}
          value={row.purpose}
          onChange={(event) =>
            onChange(row.id, "purpose", event.target.value)
          }
          placeholder="Describe the purpose of this connection"
          variant="modal"
          label="Purpose"
        />
      </div>
      <div className="node-kind-builder__grid-span-2">
        <Textarea
          id={`matrix-defaultSettings-${row.id}`}
          name="defaultSettings"
          rows={4}
          value={row.defaultSettings}
          onChange={(event) =>
            onChange(row.id, "defaultSettings", event.target.value)
          }
          placeholder='{"weight": 0.5, "delayMs": 10}'
          variant="modal"
          label="Default Settings (JSON)"
          hint="Default settings as JSON object"
        />
      </div>
      <Select
        id={`matrix-scope-${row.id}`}
        name="scope"
        value={row.scope}
        onChange={(event) =>
          onChange(row.id, "scope", event.target.value)
        }
        variant="modal"
        options={scopeOptions}
        placeholder="Select scope"
        label="Scope"
        hint="ONTOLOGY, GRAPH, or NODE"
      />
      <TextInput
        id={`matrix-version-${row.id}`}
        name="version"
        type="number"
        value={row.version}
        onChange={(event) =>
          onChange(row.id, "version", event.target.value)
        }
        placeholder="1"
        variant="modal"
        label="Version"
      />
    </div>
  );
};

export default SynapseKindMatrixForm;

